import { Form as FormInitial } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    Form,
    FormItem,
    ModalItem,
    InputNumberItem,
    ButtonItem,
    ErrorItem,
    SelectInsumosItem,
} from "../../../../Components/Items";

// Modal para elegir/editar, por línea de Pedido o Venta, la lista de insumos
// que componen un "kit variable" (insumo compuesto con kitVariable activado).
// Se parte de la receta del insumo (o de lo ya elegido antes en esta línea) y
// se puede agregar/quitar/cambiar cualquier insumo del catálogo libremente.
class ElegirComponentesKit extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        // insumoId (string) -> insumo completo, para precargar el nombre en el
        // SelectInsumosItem de cada fila sin depender del catálogo ya cargado
        // en la pantalla padre (que solo trae los insumos ya usados en el
        // documento, no necesariamente los de la receta del kit).
        insumosPrecargados: {},
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.cargarComponentesIniciales();
        }
    }

    async cargarComponentesIniciales() {
        const componentesIniciales = (this.props.componentes && this.props.componentes.length > 0)
            ? this.props.componentes
            : [{ insumoId: undefined, cantidad: undefined, descripcion: undefined }];

        const insumoIds = componentesIniciales
            .filter((valueComponente) => valueComponente && valueComponente.insumoId)
            .map((valueComponente) => valueComponente.insumoId);

        let insumoPorId = new Map();
        if (insumoIds.length > 0) {
            this.setState({ loading: true });
            const res = await axios.post(
                "insumos/selectInsumosPorIds",
                { empresaId: this.props.empresaId, insumoIds },
                { headers: this.props.headersToken }
            ).catch((err) => {
                console.error("Error cargando insumos del kit:", err);
                return null;
            });
            if (res?.data?.success === 2) {
                insumoPorId = new Map(res.data.insumos.map((valueInsumo) => [valueInsumo._id.toString(), valueInsumo]));
            }
        }

        const insumosPrecargados = {};
        const componentesResueltos = componentesIniciales.map((valueComponente) => {
            if (!valueComponente || !valueComponente.insumoId) return valueComponente;
            const insumoResuelto = insumoPorId.get(valueComponente.insumoId.toString());
            if (insumoResuelto) {
                insumosPrecargados[valueComponente.insumoId.toString()] = insumoResuelto;
            }
            return {
                ...valueComponente,
                descripcion: valueComponente.descripcion || insumoResuelto?.descripcion,
            };
        });

        this.setState({ loading: false, insumosPrecargados });
        this.formRef.current?.setFieldsValue({ componentes: componentesResueltos });
    }

    cerrar(componentes) {
        this.props.cerrarElegirComponentesKit(componentes || []);
        this.setState({ insumosPrecargados: {} });
    }

    onFinish(values) {
        const componentesFiltrados = (values.componentes || []).filter(
            (valueComponente) => valueComponente && valueComponente.insumoId
        );
        this.cerrar(componentesFiltrados);
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onCancel() {
        const componentesActuales = this.formRef.current?.getFieldValue("componentes") || [];
        const componentesFiltrados = componentesActuales.filter(
            (valueComponente) => valueComponente && valueComponente.insumoId
        );
        this.cerrar(componentesFiltrados);
    }

    render() {
        return (
            <ModalItem
                title="Elegir Insumos Del Kit"
                visible={this.props.visible}
                onCancel={this.onCancel.bind(this)}
                spinning={this.state.loading}
                paddingTop
                width={800}
            >
                <Form
                    ref={this.formRef}
                    name="ElegirComponentesKit"
                    layout
                    bottom={
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                            Guardar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormInitial.List name="componentes">
                        {(fields, { add, remove }) => (
                            <>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="th-border" style={{ width: "80%" }}>Insumo</th>
                                            <th className="th-border" style={{ width: "18%" }}>Cantidad</th>
                                            <th className="th-border" style={{ width: "2%" }}></th>
                                        </tr>
                                    </thead>
                                    {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                                        const insumoIdFila = this.formRef.current?.getFieldValue(["componentes", arrayKey, "insumoId"]);
                                        const insumoPreCargado = insumoIdFila ? this.state.insumosPrecargados[insumoIdFila.toString()] : undefined;
                                        return (
                                        <tbody key={key}>
                                            <tr>
                                                <td className="td-border">
                                                    <FormItem
                                                        {...restField}
                                                        name={[name, "insumoId"]}
                                                        fieldKey={[arrayKey, "insumoId"]}
                                                        required
                                                        noStyle
                                                    >
                                                        <SelectInsumosItem
                                                            empresaId={this.props.empresaId}
                                                            headersToken={this.props.headersToken}
                                                            sinBorde
                                                            dropdownMatchSelectWidth={600}
                                                            width="100%"
                                                            placeholder="Insumo"
                                                            tiposInsumos="inventariablesEquivalencias"
                                                            insumoPreCargado={insumoPreCargado}
                                                            onChange={(value, insumo) => {
                                                                this.setState((prev) => ({
                                                                    insumosPrecargados: value ? { ...prev.insumosPrecargados, [value.toString()]: insumo } : prev.insumosPrecargados,
                                                                }));
                                                                this.formRef.current?.setFields([
                                                                    {
                                                                        name: ["componentes", arrayKey, "descripcion"],
                                                                        value: insumo?.descripcion,
                                                                    },
                                                                ]);
                                                            }}
                                                        />
                                                    </FormItem>
                                                    <FormItem
                                                        {...restField}
                                                        name={[name, "descripcion"]}
                                                        fieldKey={[arrayKey, "descripcion"]}
                                                        noStyle
                                                        hidden
                                                    >
                                                        <input />
                                                    </FormItem>
                                                </td>
                                                <td className="td-border">
                                                    <FormItem
                                                        {...restField}
                                                        name={[name, "cantidad"]}
                                                        fieldKey={[arrayKey, "cantidad"]}
                                                        numberCero
                                                        noStyle
                                                        required
                                                    >
                                                        <InputNumberItem sinBorde />
                                                    </FormItem>
                                                </td>
                                                <td>
                                                    {fields.length > 1 && (
                                                        <MinusCircleOutlined
                                                            onClick={() => remove(name)}
                                                            style={{ alignSelf: "center", justifySelf: "center" }}
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                        );
                                    })}
                                </table>
                                <FormItem noStyle>
                                    <ButtonItem
                                        style={{ marginTop: 10, marginBottom: 10 }}
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                    >
                                        Agregar Insumo
                                    </ButtonItem>
                                </FormItem>
                            </>
                        )}
                    </FormInitial.List>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ElegirComponentesKit);
